import React from 'react';
import BaseIcon, { IIconProps, getIconDimension } from '../../BaseIcon';
import { getColor } from '../../colors';

const GhostIconFilled: React.FC<IIconProps> = ({
  size = 'medium',
  width,
  height,
  color = 'currentColor',
  secondaryColor = 'color1',
  ...props
}) => {
  const iconDimension = getIconDimension(size);

  return (
    <BaseIcon
      viewBox="0 0 24 24"
      width={width || iconDimension}
      height={height || iconDimension}
      fill="none"
      color={getColor(color)}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5 1H7.5L6 1.5L4 3L3 4V8.5L2.5 17.5L3 21.5L3.5 22.5L6.5 20.5L9 23L12 20.5L15 22.5L17.5 20.5L20 22H21V4L19.5 2.5L18 1.5L16.5 1Z"
        fill={getColor(secondaryColor)}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.91797 5.97501C1.91797 2.74414 4.5371 0.125 7.76797 0.125H16.232C19.4629 0.125 22.082 2.74413 22.082 5.975V21.2782C22.082 22.8184 20.31 23.6841 19.095 22.7375L17.7486 21.6884L16.4531 23.128C15.7553 23.9034 14.5549 23.9489 13.8004 23.2286L12.1792 21.6808L10.2568 23.3514C9.52034 23.9914 8.41342 23.9494 7.72753 23.2555L6.1657 21.6754L4.92977 22.6727C3.71973 23.6492 1.91797 22.7879 1.91797 21.233V5.97501ZM7.76797 1.825C5.47599 1.825 3.61797 3.68302 3.61797 5.97501V21.233C3.61797 21.274 3.62847 21.2981 3.63945 21.3147C3.65249 21.3344 3.67395 21.3544 3.70328 21.3684C3.7326 21.3824 3.76158 21.3866 3.78511 21.3843C3.80493 21.3825 3.83027 21.3755 3.86217 21.3498L5.34437 20.1537C5.88374 19.7184 6.66509 19.7623 7.15231 20.2552L8.9366 22.0605C8.99221 22.1167 9.08196 22.1201 9.14167 22.0682L11.3047 20.1885C11.8308 19.7313 12.6184 19.7497 13.1225 20.231L14.9743 21.999C15.0355 22.0574 15.1328 22.0537 15.1894 21.9908L16.703 20.3089C17.1769 19.7822 17.9773 19.7116 18.5362 20.147L20.1398 21.3965C20.2383 21.4732 20.382 21.403 20.382 21.2782V5.975C20.382 3.68302 18.524 1.825 16.232 1.825H7.76797Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.6525 9.37522C16.6525 9.06843 16.3611 8.70481 15.854 8.70481C15.3468 8.70481 15.0554 9.06843 15.0554 9.37522H13.3554C13.3554 8.00262 14.5401 7.00481 15.854 7.00481C17.1678 7.00481 18.3525 8.00262 18.3525 9.37522H16.6525Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.94551 9.37522C8.94551 9.06843 8.65405 8.70481 8.14693 8.70481C7.63981 8.70481 7.34835 9.06843 7.34835 9.37522H5.64835C5.64835 8.00262 6.83308 7.00481 8.14693 7.00481C9.46078 7.00481 10.6455 8.00262 10.6455 9.37522H8.94551Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default GhostIconFilled;
